export default __webpack_public_path__ + "static/empty-star-b0a5a61f21261f7f6f317e9b71e338af.svg";